import { Component, OnInit } from '@angular/core';
import {InspectionDeliveryRequest} from "../../../classes/inspectionDeliveryRequest";
import {InspectionOrder} from "../../../classes/inspectionOrder";
import {ActivatedRoute, Router} from "@angular/router";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {InspectionDeliveryRequestService} from "../../../services/inspectionDeliveryRequest";
import {InspectionOrderService} from "../../../services/inspectionOrder";
import {HttpErrorResponse} from "@angular/common/http";
import {mergeMap, tap} from "rxjs/operators";

@Component({
  selector: 'app-inspection-delivery-request-update',
  templateUrl: './inspection-delivery-request-update.component.html',
  styleUrls: ['./inspection-delivery-request-update.component.css']
})
export class InspectionDeliveryRequestUpdateComponent implements OnInit {

  inspectionDeliveryRequest = new InspectionDeliveryRequest();
  inspectionOrder = new InspectionOrder();
  inspectionDeliveryRequestUpdateResult = true;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private modalService: NgbModal,
              private inspectionDeliveryRequestService: InspectionDeliveryRequestService,
              private inspectionOrderService: InspectionOrderService) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.inspectionDeliveryRequestService.getByID(params.get('id'))
          .pipe(
              tap((inspectionDeliveryRequest: any) => {
                this.inspectionDeliveryRequest = inspectionDeliveryRequest;
              }),
              mergeMap(() => this.inspectionOrderService.getByID((this.inspectionDeliveryRequest.fk_id_inspection_order as number).toString())),
          )
          .subscribe({
            next: (inspectionOrder: any) => {
              this.inspectionOrder = inspectionOrder;
            },
            error: (err: HttpErrorResponse) => {
              console.log(err);
            }
          });
    });
  }

  onSubmit() {
    this.inspectionDeliveryRequestService.update(this.inspectionDeliveryRequest)
        .subscribe({
          next: () => {
            this.router.navigate(['/inspection/order/' + this.inspectionOrder.id_inspection_order]);
          },
          error: (err: HttpErrorResponse) => {
            this.inspectionDeliveryRequestUpdateResult = false;
            console.log(err);
          }
        });
  }

}
